import React from 'react';
import { Search, Filter, X, Calendar, Building2, FileText, AlertCircle } from 'lucide-react';

const HangarLeaseSearchFilters = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  leaseTypeFilter,
  onLeaseTypeFilterChange,
  showOnlyArrears,
  onShowOnlyArrearsChange,
  onClearFilters
}) => {
  const hasActiveFilters = statusFilter !== 'all' || leaseTypeFilter !== 'all' || showOnlyArrears;

  return (
    <div className="space-y-3">
      {/* Barre de recherche principale */}
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search anything... hangar number, name, location, tenant, lease number, aircraft tail..."
          className="w-full bg-gray-800/60 border border-gray-700 rounded-lg pl-9 pr-10 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-emerald-500/50 transition-colors"
        />
        {searchTerm && (
          <button
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-white"
          >
            <X size={14} />
          </button>
        )}
      </div>

      {/* Ligne de filtres */}
      <div className="flex flex-wrap items-center gap-2">
        <Filter size={14} className="text-gray-500" />
        
        {/* Filtre statut hangar */}
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          className="bg-gray-800/60 border border-gray-700 rounded-lg px-3 py-1.5 text-xs text-white focus:outline-none focus:border-emerald-500/50"
        >
          <option value="all">All Hangars</option>
          <option value="occupied">Occupied</option>
          <option value="available">Available</option>
          <option value="maintenance">Maintenance</option>
        </select>

        {/* Filtre type de bail */}
        <select
          value={leaseTypeFilter}
          onChange={(e) => onLeaseTypeFilterChange(e.target.value)}
          className="bg-gray-800/60 border border-gray-700 rounded-lg px-3 py-1.5 text-xs text-white focus:outline-none focus:border-emerald-500/50"
        >
          <option value="all">All Lease Types</option>
          <option value="active">Active Only</option>
          <option value="ground">Ground Lease</option>
          <option value="services_only">Services Only</option>
        </select>

        {/* Toggle loyers en retard */}
        <button
          onClick={() => onShowOnlyArrearsChange(!showOnlyArrears)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs transition-colors ${
            showOnlyArrears
              ? 'bg-red-500/20 text-red-400 border border-red-500/30'
              : 'bg-gray-800/60 text-gray-400 border border-gray-700 hover:text-white'
          }`}
        >
          <AlertCircle size={12} />
          Rent Arrears Only
        </button>

        {/* Bouton clear filters */}
        {hasActiveFilters && (
          <button
            onClick={onClearFilters}
            className="text-xs text-gray-500 hover:text-white transition-colors flex items-center gap-1 px-2 py-1.5"
          >
            <X size={12} />
            Clear
          </button>
        )}
      </div>

      {/* Indicateur de recherche active */}
      {searchTerm && (
        <div className="text-xs text-emerald-400 bg-emerald-500/10 inline-flex items-center gap-1 px-2 py-1 rounded">
          <Search size={10} />
          Searching for: "{searchTerm}"
        </div>
      )}
    </div>
  );
};

export default HangarLeaseSearchFilters;